import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { Presentation, FolderKanban, Award, MessageSquare, GraduationCap } from 'lucide-react';
export const Outcomes = () => {
  const outcomes = [{
    icon: <Presentation size={24} data-id="element-195" />,
    label: 'Live Pitch',
    desc: 'Present to a panel of real leaders.'
  }, {
    icon: <FolderKanban size={24} data-id="element-196" />,
    label: 'Civic Venture Project',
    desc: 'A tangible portfolio piece.'
  }, {
    icon: <Award size={24} data-id="element-197" />,
    label: 'Certificate',
    desc: 'Official completion credential.'
  }, {
    icon: <MessageSquare size={24} data-id="element-198" />,
    label: 'Mentor Feedback',
    desc: 'Personalized growth insights.'
  }, {
    icon: <GraduationCap size={24} data-id="element-199" />,
    label: 'University Story',
    desc: 'Standout material for applications.'
  }];
  return <section id="outcomes" className="py-24 bg-navy relative" data-id="element-200">
      <div className="absolute inset-0 bg-noise pointer-events-none z-10" data-id="element-201" />

      <div className="max-w-7xl mx-auto px-6 relative z-20" data-id="element-202">
        <SectionHeader title="Tangible Outcomes" subtitle="What you walk away with after three weeks." dark data-id="element-203" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-204">
          {outcomes.map((outcome, idx) => <motion.div key={outcome.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} whileHover={{
          y: -5,
          scale: 1.02
        }} className="bg-indigo/40 border border-gold/20 p-6 rounded-sm relative overflow-hidden group hover:border-kesari/60 hover:bg-indigo/60 transition-all duration-300 shadow-lg" data-id="element-205">
              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-gold/30 group-hover:border-kesari transition-colors" data-id="element-206" />

              {/* Hover gradient glow */}
              <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-kesari/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-207" />

              <motion.div className="text-gold mb-6 group-hover:text-kesari transition-colors relative z-10" whileHover={{
            rotate: 5,
            scale: 1.1
          }} data-id="element-208">
                {outcome.icon}
              </motion.div>
              <div className="font-serif text-lg text-ivory mb-2 relative z-10" data-id="element-209">
                {outcome.label}
              </div>
              <div className="font-sans text-sm text-parchment/60 relative z-10" data-id="element-210">
                {outcome.desc}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};